module.exports = {
          srcSet: __webpack_public_path__ + "294793a6000824b063bf75764eace4d8-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "294793a6000824b063bf75764eace4d8-2336.png",width: 2336,height: 396}],
          src: __webpack_public_path__ + "294793a6000824b063bf75764eace4d8-2336.png",
          toString:function(){return __webpack_public_path__ + "294793a6000824b063bf75764eace4d8-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ALsiJvzONzv/3Dg+/utBSP75OkP/8yQq/ul0P/7nRin+wmhf/5g5MvkAsBca/MIlKv/RKS/+4TA2/vIuOP/3KSv+5WVA/uhKOf7Ml4r/x5eQ+Ut9LuQFeJv1AAAAAElFTkSuQmCC",
          width: 2336,
          height: 396
        }